import React, { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  href: string;
  target: string;
  deqType: string;
  deqLabel: string;
  deqObject: {
    elementTarget: string;
    componentType: string;
    elementAction?: string;
  };
  deqGroupTitle: string;
  deqGroupType: string;
}

const TextLink = ({
  href,
  target,
  deqType,
  deqLabel,
  deqObject,
  deqGroupTitle,
  deqGroupType,
  children,
}: Props) => (
  <a
    href={href}
    target={target}
    rel={target}
    data-element-type={deqType}
    data-element-label={deqLabel.toLowerCase()}
    data-component-type={deqObject.componentType}
    data-element-target={deqObject.elementTarget || ''}
    data-element-action={deqObject?.elementAction || undefined}
    data-content-group-title={deqGroupTitle}
    data-content-group-type={deqGroupType}
  >
    {children}
  </a>
);

export default TextLink;
